import { useRef } from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { firstDayOfWeekAsKey } from 'modules/core/lib/firstDayOfWeek'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { hasRegularAccessOrNotEmployee } from 'modules/employees/lib/utils'
import FormatsSelector from 'modules/settings/components/FormatsSelector'
import LanguageSelector from 'modules/settings/components/LanguageSelector'
import TimeFormatSelector from 'modules/settings/components/TimeFormatSelector'
import PersonalForm from 'modules/settings/lib/forms/Personal'

import FirstWeekDaySelector from './_FirstWeekDaySelector'

const PersonalSettings = () => {
  const { employee } = useCurrentSession()
  const currentUser = users.current
  const withRegularAccess = hasRegularAccessOrNotEmployee(employee)
  const withLocaleSelector = !hasFeature('ngo_locale')

  const personalForm = useRef(
    new PersonalForm({
      first_day_of_week: firstDayOfWeekAsKey(currentUser.attributes.first_day_of_week),
      locale: currentUser.attributes.locale,
      time_format: currentUser.attributes.time_format,
    })
  ).current

  const { running, performAction: onSubmitPersonal } = useAsyncAction(async () => {
    if (!personalForm.isDirty) return

    await personalForm.save(currentUser)

    window.location.reload()
  })

  return (
    <Section.Form
      illustration="user-edit"
      title={i18n.t('personal_settings.personal_settings')}
      description={i18n.t('personal_settings.configure')}
      onSubmit={onSubmitPersonal}
      submitLabel={i18n.t('common.save')}
      isDirty={personalForm.isDirty}
      disabled={running}
    >
      {!!withLocaleSelector && (
        <>
          <LanguageSelector form={personalForm} />
          <FormatsSelector form={personalForm} />
        </>
      )}
      <TimeFormatSelector personalForm={personalForm} />

      {!!withRegularAccess && <FirstWeekDaySelector personalForm={personalForm} />}
    </Section.Form>
  )
}

export default observer(PersonalSettings)
